export default "https://legacy.eskolare-development.com/images/logo-default-institutions.png";